import global_axios from '../../funciones_globales/interaccionapi';
import  { CARGAR_TRANSFERENCIA } from './actionTypes';
import { INICIALIZAR_FORM } from '../generales/actionTypes';
import { completar_String } from '../../funciones_globales/format';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';

export const cargar_Transferencia = (transferencia) => {
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			method: 'GET',
			url: '/transferencias/' + transferencia
		})			
		.then( response => {			
			dispatch({
				type: CARGAR_TRANSFERENCIA,
				data: response.data				
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar transferencia', mensaje: msgError}
			});
		});
	}
}

export const cargar_ValoresIniciales = (fechaProceso) => {
	return (dispatch) => {
		return global_axios({
			method: 'GET',
			url: '/secuenciales/Transferencia'
		})
		.then( response => {
			let cod_secuencial = completar_String(response.data.codigo, '0', 6);
			dispatch({
				type: INICIALIZAR_FORM,
				data: {	codigo: cod_secuencial,
						tipo: 'MAN',
						fecha: fechaProceso
					}
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;			
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar valores iniciales de transferencia', mensaje: msgError}
			});
		});
	}
}